import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Ternary from "src/components/ternary";
import useSettings from "src/hooks/useSettings";
import Horizontal from "./components/horizontal";
import Vertical from "./components/vertical";

// Save the current user path on every navigation so SmartRootIndex can
// restore it when MetaMask Mobile's in-app browser refreshes the WebView
// at "/" instead of the current URL.
const useTrackLastUserPath = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/user/")) return;
    try {
      localStorage.setItem(
        "lastUserPath",
        JSON.stringify({
          path: pathname + (search || ""),
          timestamp: Date.now(),
        })
      );
    } catch {
      // Storage unavailable; skip.
    }
  }, [pathname, search]);
};

const Layout = () => {
  useTrackLastUserPath();

  const config = JSON.parse(localStorage.getItem("menu") || "[]");
  const { themeLayout } = useSettings();
  const verticalLayout = themeLayout === "vertical";

  return (
    <Ternary
      when={verticalLayout}
      then={<Vertical navConfig={config} />}
      otherwise={<Horizontal navConfig={config} />}
    />
  );
};
export default Layout;
